import React, { useState, useRef, useEffect } from "react";
import { Link,useLocation,useParams} from "react-router-dom";
import { Pagination, EffectFade, Autoplay } from "swiper/modules"
import { useReactToPrint } from 'react-to-print';

import { useTranslation } from "react-i18next";

import swal from 'sweetalert';

import Goodbtn from "../assets/good_btn.png";
import Normalbtn from "../assets/normal_btn.png";
import Badbtn from "../assets/bad_btn.png";

import SpinIcon from '../assets/spin_stress.gif';

import { Get, GetList, GetTime } from '../lib/DeviceData';

import SingleCare from "../assets/Nurion-logo.png";

import ttsAudio1 from "../assets/sound/tts_09_1.mp3"; // 매우낮음
import ttsAudio2 from "../assets/sound/tts_09_2.mp3"; // 낮음
import ttsAudio3 from "../assets/sound/tts_09_3.mp3"; // 적정
import ttsAudio4 from "../assets/sound/tts_09_4.mp3"; // 높음
import ttsAudio5 from "../assets/sound/tts_09_5.mp3"; // 매우높음

import ttsAudio_a from "../assets/sound/tts_10.mp3"; 
import ttsAudio_b from "../assets/sound/tts_11.mp3"; 
import ttsAudio_c from "../assets/sound/tts_12.mp3"; 




const Result = () => {
    const { t } = useTranslation();
    const componentRef1 = useRef(null);

    
    const audioRef = useRef(null);

    const [audioQueue, setAudioQueue] = useState([]);
    
    const ttsAudioList = [null, ttsAudio1, ttsAudio2, ttsAudio3, ttsAudio4, ttsAudio5];
    

    const followUpAudios = [ttsAudio_a, ttsAudio_b, ttsAudio_c];

    const [highlightIndex, setHighlightIndex] = useState(null);

    const location = useLocation();
    const userInfo = { ...location.state };

    
    const [bucketTime, setbucketTime] = useState('');
    const [HrTime, sethrTime] = useState(0);
    const [RrTime, setrrTime] = useState(0);

    const [RMSSD_set, setrmssd] = useState(0.0);
    const [SDNN_set, setsdnn] = useState(0.0);
    const [pNN50_set, setpnn50] = useState(0.0);

    const [baevsky_si_set, setbaevsky] = useState(0.0);

    const [Stress_LV, setstresslevel] = useState(0.0);
    const [Stress_LV_TEXT, setstresslevel_text] = useState('');

    const [device_sn, SetDevice_sn] = useState(0);
    const [device_no, SetDevice_no] = useState(0);
    const [member_no, SetMemeber_no] = useState(0);
    const [name, SetName] = useState('');
    const [sex, SetSex] = useState(0);
    const [birth, SetBirth] = useState(0);
    const [feel, SetFeel] = useState('');

    const [RMSSD_level, setrmssd_level] = useState(0);
    const [SDNN_level, setsdnn_level] = useState(0);
    const [pNN50_level, setpnn50_level] = useState(0);

    useEffect(() => {
        if (Stress_LV >= 1 && Stress_LV <= 5) {
            const initial = ttsAudioList[Stress_LV];
            setAudioQueue([initial, ...followUpAudios]); // 첫 오디오 + 이어서 재생할 목록
        }
    }, [Stress_LV]);

    // 컴포넌트 마운트 시 자동 재생
    useEffect(() => {
        
        const audio = audioRef.current;
        if (!audio || audioQueue.length === 0) return;

        let timeoutId = null;

        const playNext = () => {
            if (audioQueue.length === 0) {
                setHighlightIndex(null); // 강조 효과 제거
                return; // 🔒 종료 조건
            }

            const [currentAudio, ...rest] = audioQueue;

            // 강조 인덱스 설정
            const highlightMap = {
                [ttsAudio_a]: 0,
                [ttsAudio_b]: 1,
                [ttsAudio_c]: 2,
            };
            setHighlightIndex(highlightMap[currentAudio] ?? null);

            audio.src = currentAudio;
            audio.play().catch((err) => console.warn("Autoplay failed:", err));
        };

        const handleEnded = () => {
            const [_, ...rest] = audioQueue;
            setAudioQueue(rest);

            // 다음 오디오가 있다면 1.5초 후 재생
            if (rest.length > 0) {
                timeoutId = setTimeout(() => {
                    playNext();
                }, 1500);
            } else {
                setHighlightIndex(null); // 마지막 오디오 끝나고 강조 해제
            }
        };

        audio.addEventListener("ended", handleEnded);
        playNext();

        return () => {
            clearTimeout(timeoutId);
            audio.removeEventListener("ended", handleEnded);
        };
    }, [audioQueue]);




    useEffect(()=> {
        fetchData();
    }, []);

    const fetchData = () => {

        try {

            const data = userInfo;


            sethrTime(Math.round(data.hr));
            setrrTime(Math.round(data.rr));
            setbucketTime(data.date);

            SetDevice_sn(data.device_sn);
            SetDevice_no(data.device_no);
            SetMemeber_no(data.member_no);
            SetName(data.name);
            SetSex(data.sex);
            SetBirth(data.birth);
            SetFeel(data.feel);



            setrmssd(parseFloat(Number(data.rmssd).toFixed(1)));
            setsdnn(parseFloat(Number(data.sdnn).toFixed(1)));
            setpnn50(parseFloat(Number(data.pnn50).toFixed(1)));
            setbaevsky(data.baevsky_si);

            if(Math.round(Number(data.rmssd))<=20){
                setrmssd_level(1);
            }else if(Math.round(Number(data.rmssd))>20 && Math.round(Number(data.rmssd))<80){
                setrmssd_level(2);
            }else{
                setrmssd_level(3);
            }



            if(Math.round(Number(data.sdnn))<=30){
                setsdnn_level(1);
            }else if(Math.round(Number(data.sdnn))>30 && Math.round(Number(data.sdnn))<100){
                setsdnn_level(2);
            }else{
                setsdnn_level(3);
            }

            if(Math.round(Number(data.pnn50))<=20){
                setpnn50_level(1);
            }else{
                setpnn50_level(2);
            }




            if(Number(data.baevsky_si) <= 100){
                setstresslevel(1);
                setstresslevel_text("매우낮음");
            }else if(Number(data.baevsky_si) <= 300){
                setstresslevel(2);
                setstresslevel_text("낮음");
            }else if(Number(data.baevsky_si) <= 500){
                setstresslevel(3);
                setstresslevel_text("적정");
            }else if(Number(data.baevsky_si) <= 700){
                setstresslevel(4);
                setstresslevel_text("높음");
            }else{
                setstresslevel(5);
                setstresslevel_text("매우높음");
            }

            // 100 미만: 최적의 적응, 낮은 스트레스.
            // 100-300: 정상적인 적응, 가벼운 스트레스.
            // 300-500: 보통 스트레스, 조절 시스템의 긴장.
            // 500-700: 현저한 스트레스, 조절 시스템의 상당한 긴장, 과로 가능성.
            // 700 초과: 심각한 스트레스, 적응 메커니즘의 붕괴, 병리학적 위험 높음.


        } catch (error) {
            console.log("Error fetching data:", error);
        }
    }

    
    const styles = {
    	textAlign:"left",
        width: "55%",
    }

    const handlePrint = useReactToPrint({
        contentRef: componentRef1,
        documentTitle: "스트레스측정리포트" ,
        pageStyle: "@page { size: A4; ratio:65%;margin:10; }body {-webkit-print-color-adjust: exact;}" 
    });

    var sdnn_per=0;
    if(SDNN_set<=10){
        sdnn_per=SDNN_set;
    }else{
        sdnn_per=SDNN_set-7;
    }


    var pnn_per=0;
    if(pNN50_set==100){
        pnn_per=pNN50_set-8;
    }else{
        pnn_per=pNN50_set;
    }
    
    return (
        <main className="main-container">
            
            <audio ref={audioRef} src={ttsAudioList[Stress_LV]} autoPlay />

            <div className="report_area" ref={componentRef1}>
                <div className="top_area">
                    <img src={SingleCare} className="top_logo_report" />
                    <h2>
                        누리온 스트레스 측정 리포트
                    </h2>
                </div>
                <div className="desc_area">
                    <table>
                        <thead>
                            <tr>
                                <th>성명</th>
                                <th>측정일</th>
                                <th>Device Info</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{name}</td>
                                <td>{bucketTime}</td>
                                <td>{device_sn}</td>
                            </tr>
                             {/* <tr>
                                <td>박승조</td>
                                <td>19950409</td>
                                <td>보통</td>
                                <td>20250516 11:09:43</td>
                                <td>K202505140001</td>
                            </tr> */}
                        </tbody>
                    </table>

                    <div className="flex_area">
                        <div className="w50 left">
                            <ul>
                                <li>
                                    <h3>평균 심박수(HR)</h3>
                                    <span><i style={{color:"#ED4D4D"}}>{HrTime}</i> BPM</span>
                                </li>
                                <li>
                                    <h3>평균 호흡수(RR)</h3>
                                    <span><i style={{color:"#347deb"}}>{RrTime}</i> BPM</span>
                                </li>
                            </ul>
                        </div>
                        <div className="w50 right">
                            <h3 className="title">스트레스 레벨</h3>
                            <div className="progress_level">
                                <div className="progress">
                                    <div className={`level_icon level${Stress_LV}`}></div>
                                </div>
                                <div className="level_text">
                                    <div className="level_text_area">매우낮음</div>
                                    <div className="level_text_area">낮음</div>
                                    <div className="level_text_area">적정</div>
                                    <div className="level_text_area">높음</div>
                                    <div className="level_text_area">매우높음</div>
                                </div>
                            </div>

                            <div className="Stress_level">
                                <h2>{Stress_LV_TEXT}</h2>
                            </div>
                        </div>
                    </div>

                    <div className="stress_area">
                        <div className="doc-root">
                            <table>
                                <tbody>
                                    <tr>
                                        <th colSpan={2}>스트레스 지표</th>
                                        <th style={{width:"30%"}}>측정값</th>
                                    </tr>
                                    <tr>
                                        <td className={highlightIndex === 0 ? "highlight" : ""} style={{width:"20%"}}>스트레스 반응성<br />(RMSSD)</td>
                                        <td>
                                            <div className="stress_bar">
                                                <div className="bar1"></div>
                                                <div className="bar2"></div>
                                                <div className="bar3"></div>
                                                <div className={`level_icon level${RMSSD_level}`} style={{"left":RMSSD_set+4+"%"}}></div>
                                            </div>
                                            <div className="level_text">
                                                <div className="level_text_area">20</div>
                                                <div className="level_text_area">80</div>
                                            </div>
                                        </td>
                                        <td>
                                            <span>
                                                <strong>{RMSSD_set} ms</strong><br />
                                                {/* <i>🥵</i> */}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={highlightIndex === 1 ? "highlight" : ""} style={{width:"20%"}}>스트레스 저항력<br />(SDNN)</td>
                                        <td>
                                            <div className="stress_bar">
                                                <div className="bar1"></div>
                                                <div className="bar2"></div>
                                                <div className="bar3"></div>
                                                <div className={`level_icon level${SDNN_level}`} style={{"left":sdnn_per+"%"}}></div>
                                            </div>
                                            <div className="level_text">
                                                <div className="level_text_area">30</div>
                                                <div className="level_text_area">100</div>
                                            </div>
                                        </td>
                                        <td>
                                            <span>
                                                <strong>{SDNN_set} ms</strong><br />
                                                {/* <i>🥵</i> */}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={highlightIndex === 2 ? "highlight" : ""} style={{width:"20%"}}>자율신경 건강도<br />(pNN50)</td>
                                        <td>
                                            <div className="stress_bar pnn">
                                                <div className="bar1"></div>
                                                <div className="bar2"></div>
                                                <div className={`level_icon level${pNN50_level}`} style={{"left":pnn_per+4+"%"}}></div>
                                            </div>
                                            <div className="level_text">
                                                <div className="level_text_area" style={styles}>20</div>
                                            </div>
                                        </td>
                                        <td>
                                            <span>
                                                <strong>{pnn_per} %</strong><br />
                                                {/* <i>🥵</i> */}
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="HRV_graph">
                        <p>
                            <b>RMSSD</b> (19.8 ~ 59.6 ms 정상):<br />스트레스 반응성을 나타내며, 자율신경계의 안정성을 반영함. RMSSD 값이 낮으면 긴장된 상태거나 자율신경계 균형이 불안정할 수 있음.
                        </p>
                        <p>
                            <b>SDNN</b> (29.1 ~ 70.1 ms 정상):<br />신체의 스트레스 저항력을 나타내는 지표임. SDNN 값이 낮으면 신체가 스트레스에 적응하지 못하고, 누적된 스트레스가 있을 가능성이 높음.
                        </p>
                        <p style={{marginBottom : 0}}>
                            <b>pNN50</b> (20% 이상 건강):<br />두 심박 간격 차이가 50ms를 초과하는 비율을 나타내며, 자율신경계의 건강도를 평가함. pNN50이 낮으면 자율신경계의 유연성이 부족할 수 있음.
                        </p>
                    </div>
                </div>

                <p className="bottom_text">(알림) 이 리포트는 누리온 스트레스 측정 키오스크로 측정한 생체 신호와 스트레스 상태를 분석한 개인 건강 관리용 정보입니다. 해당 누리온 스트레스 측정 키오스크는 의료기기가 아니므로, 이 정보를 질병의 진단, 치료, 예방 등의 의료 목적으로 사용하지 마세요. 건강 상태를 참고하는 용도로만 활용하시기 바랍니다.</p>
            </div>

            <button className="print_ico" onClick={() => handlePrint()}>인쇄하기</button>
        </main>
    );
};

export default Result;
